import { useLang } from 'hooks/lang';

import { loaders } from 'entities';

import { Skeleton, RadioInput, Column, Label } from 'components/Blocks';

import { StepComponentProps } from '../types';
import { UsersIcon } from 'components/Icons';

export function TeamResponsible({
  state,
  handleChange,
}: Pick<StepComponentProps, 'state' | 'handleChange'>) {
  const { t } = useLang();

  const { loading: loadingTeams, data: dataTeams } = loaders.teams.list.use({
    defaultValue: [],
  });

  const teamsThatCanAssumeProjects = dataTeams.filter(({ canAssumeProject }) => canAssumeProject);

  return (
    <Column>
      <h6 className="mb-2">{t('final-details')}</h6>

      <Label icon={UsersIcon}>{t('choose-team')}</Label>

      {loadingTeams ? (
        <Skeleton width="100%" height={42} />
      ) : (
        <RadioInput
          name="teamResponsible"
          value={state.teamResponsible}
          onChange={handleChange}
          containerClassName="grid grid-cols-4 tablet:grid-cols-3 phone:grid-cols-2 small_phone:grid-cols-1"
          addDot={false}
          className="rounded-lg border p-2 transition-colors hover:bg-hover"
          selectedClassName="border-primary text-primary hover:bg-transparent"
          options={teamsThatCanAssumeProjects.map(({ name, id }) => ({
            value: id,
            label: name,
          }))}
        />
      )}
    </Column>
  );
}
